import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { useI18n } from '../i18n/I18nContext';

export const BackToHome = ({ label, testid = 'back-to-home-btn', useBack = false }) => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const displayLabel = label || t('nav.back_to_home');
  return (
    <div className="max-w-2xl mx-auto px-4 pt-6">
      <button
        data-testid={testid}
        onClick={() => (useBack ? navigate(-1) : navigate('/'))}
        className="inline-flex items-center gap-2 text-slate-600 hover:text-blue-600 font-medium text-sm transition-colors"
      >
        {useBack ? <ArrowLeft className="w-4 h-4" /> : <Home className="w-4 h-4" />}
        {displayLabel}
      </button>
    </div>
  );
};
